import { ArrowRightIcon } from '@heroicons/react/solid';
import { Drawer } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import Image from 'next/image';

import { Chapter } from '../../utils/interfaces/Library/Pdf';

interface Props {
  visible: boolean;
  onClose: () => void;
  samplePdf: boolean;
  book_id?: string;
  baseUrl: string;
  Endpoints: any;
  booksDetails?: { title: string };
  pageNumber: number;
  numPages: number;
  chaptersList?: { chapters: Chapter[] };
  chapterFieldId?: string;
  isFullScreen?: boolean;
  onChapterHandler: (id: string, startPage: number) => void;
}

const ChapterDrawer: React.FC<Props> = ({
  visible,
  onClose,
  book_id,
  baseUrl,
  Endpoints,
  booksDetails,
  pageNumber,
  numPages,
  chaptersList,
  chapterFieldId,
  onChapterHandler,
  isFullScreen,
}) => {
  const screens = useBreakpoint();
  return (
    <Drawer
      title={<div className='py-4 truncate w-fit pr-10'>Book Index</div>}
      placement='left'
      closable={true}
      onClose={onClose}
      open={visible}
      width={450}
      {...(!screens.lg && { getContainer: undefined })}
      {...(isFullScreen && { getContainer: false })}
      className='customDrawer pl-4 customHeaderDrawer '
    >
      <div className='flex items-center gap-x-5 pt-4'>
        {book_id && (
          <Image
            alt='Book Cover'
            src={`${baseUrl}/${Endpoints.getCoverImagesForBooks}/${book_id}`}
            width={60}
            height={40}
          />
        )}
        <div>
          <span className='block'>{booksDetails?.title}</span>
          <span className='text-gray-400 text-sm'>
            Pages {pageNumber} of {numPages}
          </span>
        </div>
      </div>

      {chaptersList?.chapters.length && (
        <div className='mt-4 mr-4'>
          <span className='text-lg text-fadedWhite'>Chapters</span>
          <div className='overflow-auto customScrollBar mt-2'>
            {chaptersList.chapters.map((item, index) => (
              <div
                key={item._id}
                onClick={() => {
                  onChapterHandler(item._id, item.startPage);
                  onClose();
                }}
                className='py-1 text-xs cursor-pointer text-[#808080] hover:text-gray-300'
              >
                <span className='flex justify-between text-sm'>
                  <span
                    className={`text-sm ${
                      chapterFieldId === item._id ? 'text-primary' : ''
                    }`}
                  >
                    {item.chapterNumber + 1}. {item.name}
                  </span>
                  <span
                    className={`flex items-center gap-x-2 text-sm ${
                      chapterFieldId === item._id ? 'text-primary' : ''
                    }`}
                  >
                    <ArrowRightIcon className='w-4 h-4' />
                  </span>
                </span>
                {index !== chaptersList.chapters.length - 1 && (
                  <div className='border-b border-[#1D1D1D] pt-3' />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </Drawer>
  );
};

export default ChapterDrawer;
